/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A mentor of at least one workshop the caller may read, for the list's mentor filter.
 * @export
 * @interface WorkshopMentorOption
 */
export interface WorkshopMentorOption {
    /**
     * 
     * @type {string}
     * @memberof WorkshopMentorOption
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopMentorOption
     */
    name: string;
}

/**
 * Check if a given object implements the WorkshopMentorOption interface.
 */
export function instanceOfWorkshopMentorOption(value: object): value is WorkshopMentorOption {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function WorkshopMentorOptionFromJSON(json: any): WorkshopMentorOption {
    return WorkshopMentorOptionFromJSONTyped(json, false);
}

export function WorkshopMentorOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopMentorOption {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function WorkshopMentorOptionToJSON(json: any): WorkshopMentorOption {
    return WorkshopMentorOptionToJSONTyped(json, false);
}

export function WorkshopMentorOptionToJSONTyped(value?: WorkshopMentorOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

